export const generateUUIDv4 = () => self.crypto.randomUUID()
